import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndpointService } from './endpoint.service';
import { Observable } from 'rxjs';
import { JurisdictionOrgLevel } from '../models/JurisdictionOrgLevel.model';

@Injectable({
  providedIn: 'root'
})
export class JurisdictionOrgLevelService extends EndpointService {

  constructor(http: HttpClient) {
    super(http);
  }

  create(payload: JurisdictionOrgLevel) {
    return this.http.post(this.getApiUrl('JurisdictionOrgLevel/Create'), payload);
  }

  delete(jurisdictionId: string, orgLevelId: string): Observable<Object> {
    const params = new HttpParams()
      .set('jurisdictionId', jurisdictionId.toString())
      .set('organizationLevelId', orgLevelId.toString());
      
    return this.http.delete(this.getApiUrl('JurisdictionOrgLevel/Delete'), { params });
  }
}
